<template>
  <div>
  	<a v-if="block.image_cta_url" :href="block.image_cta_url" target="_blank" style="text-decoration: none;">
      <img :src="block.image_url || '/img/frontend/blocks/1200x600.png'" width="600" height="" :alt="block.image_alt || ''" border="0" style="width: 100%; max-width: 600px; height: auto; background: #dddddd; font-family: sans-serif; font-size: 15px; line-height: 15px; color: #555555; margin: auto; display: block;" class="g-img" />
    </a>
    <img v-if="!block.image_cta_url" :src="block.image_url || '/img/frontend/blocks/1200x600.png'" width="600" height="" :alt="block.image_alt || ''" border="0" style="width: 100%; max-width: 600px; height: auto; background: #dddddd; font-family: sans-serif; font-size: 15px; line-height: 15px; color: #555555; margin: auto; display: block;" class="g-img" />
  </div>
</template>
<script>
  export default {
    props: [
      'block',
    ],
  }
</script>